

Greenmile.DataImport = Greenmile.DataImport || {};

Greenmile.DataImport.MappingScreenFactory = {

    showMapScreen: function(uploadedFile, values) {
        var clazz,
            namespace,
            primaryName = uploadedFile.primaryName,
            fileType = primaryName.substring(primaryName.length-3 , primaryName.length);


        namespace = App.Forms.DataImport.CSVConfigurations;
        clazz = Greenmile.DataImport.CSVConfigurations;

        if(namespace) {
            namespace.setFileType(fileType);
            namespace.show(values);
        } else {
            new clazz(fileType).show(values);
        }
    }
};